/**
 * @fileoverview AipLogoIcon — inline gradient SVG atom for the "Ask AIP Assist"
 * help-menu row. Uses `useId()` to suffix two linear-gradient IDs so multiple
 * instances on the same page (e.g., when the help menu is opened twice without
 * unmount) coexist without DOM-id collisions. Decorative — labeling comes from
 * the parent MenuItem's text.
 *
 * Foundry mapping: the AIP-logo glyph rendered inline beside menu rows that
 * launch AIP Assist (`bp6-menu-item` + inline svg with `paint0_linear_*` defs).
 */

import { useId } from "react";
import type { ReactElement } from "react";

interface AipLogoIconProps {
  size?: number;
  className?: string;
}

export function AipLogoIcon({ size = 16, className }: AipLogoIconProps): ReactElement {
  const id = useId();
  const gradA = `aip-grad-a-${id}`;
  const gradB = `aip-grad-b-${id}`;

  return (
    <svg data-testid="aip-logo-icon"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <defs>
        <linearGradient id={gradA} x1="2" y1="14" x2="14" y2="2" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#7B61FF" />
          <stop offset="100%" stopColor="#36C5F0" />
        </linearGradient>
        <linearGradient id={gradB} x1="4" y1="12" x2="12" y2="4" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#36C5F0" />
          <stop offset="100%" stopColor="#7B61FF" />
        </linearGradient>
      </defs>
      <path d="M2 14L8 2L14 14H2Z" fill={`url(#${gradA})`} />
      <circle cx="8" cy="10" r="2" fill={`url(#${gradB})`} />
    </svg>
  );
}
